import { apiClient } from '../client';

/**
 * Client for `/api/eos/delegate-elevate/*`. Stays in lockstep with
 * `server/src/routes/eos/delegateElevate.routes.ts` (ADR-043).
 *
 * Delegate & Elevate is a PERSONAL 2×2 audit — every endpoint operates on
 * the CALLER's own list, so there is no membership/owner parameter. Each
 * activity is bucketed into one of four energy × proficiency quadrants.
 */

export type DelegateQuadrant = 'love_great' | 'like_good' | 'dislike_good' | 'dislike_notgood';

export interface DelegateElevateItem {
  id: string;
  membershipId: string;
  activity: string;
  quadrant: DelegateQuadrant;
  order: number;
  createdAt: string;
  updatedAt: string;
}

/** The caller's own list, across all four quadrants. */
export async function listDelegateElevate(): Promise<DelegateElevateItem[]> {
  const res = await apiClient.get<{ data: DelegateElevateItem[] }>('/api/eos/delegate-elevate');
  return res.data.data;
}

export interface CreateDelegateElevateRequest {
  activity: string;
  quadrant: DelegateQuadrant;
}

export async function createDelegateElevateItem(
  body: CreateDelegateElevateRequest,
): Promise<DelegateElevateItem> {
  const res = await apiClient.post<{ data: DelegateElevateItem }>('/api/eos/delegate-elevate', body);
  return res.data.data;
}

export interface UpdateDelegateElevateRequest {
  activity?: string;
  quadrant?: DelegateQuadrant;
  order?: number;
}

export async function updateDelegateElevateItem(
  id: string,
  body: UpdateDelegateElevateRequest,
): Promise<DelegateElevateItem> {
  const res = await apiClient.put<{ data: DelegateElevateItem }>(
    `/api/eos/delegate-elevate/${encodeURIComponent(id)}`,
    body,
  );
  return res.data.data;
}

/** Hard delete — 204, no body. */
export async function deleteDelegateElevateItem(id: string): Promise<void> {
  await apiClient.delete(`/api/eos/delegate-elevate/${encodeURIComponent(id)}`);
}
